import { NgModule } from '@angular/core';
import { ScrollDirective } from './scroll.directive';
import { InspireScrollDirective } from './inspire-scroll.directive';

@NgModule({
  imports: [],
  declarations: [ScrollDirective, InspireScrollDirective],
  exports: [ScrollDirective, InspireScrollDirective]
})
export class ScrollModule {}
